<template>
  <svg aria-hidden="true" focusable="false" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g id="_22-paper_stack" data-name="22-paper stack">
      <path
        d="m26.35938 47.76855a1.00038 1.00038 0 0 0 1.248.0254l34-26a.9999.9999 0 0 0 .0332-1.5625l-24-20a1.00012 1.00012 0 0 0 -1.248-.0254l-34 26a.9999.9999 0 0 0 -.0332 1.5625zm10.61425-45.48925 22.42383 18.6875-32.37109 24.7539-22.42383-18.6875z"
      />
      <path
        d="m60.39258 36.20605-33.36621 25.51465-23.38575-19.48925a1.00053 1.00053 0 1 0 -1.28124 1.5371l24 20a1.00038 1.00038 0 0 0 1.248.0254l34-26a.99966.99966 0 0 0 -1.21484-1.5879z"
      />
      <path
        d="m60.39258 31.20605-33.36621 25.51465-23.38575-19.48925a1.00053 1.00053 0 1 0 -1.28124 1.5371l24 20a1.00038 1.00038 0 0 0 1.248.0254l34-26a.99966.99966 0 0 0 -1.21484-1.5879z"
      />
      <path
        d="m60.39258 26.20605-33.36621 25.51465-23.38575-19.48925a1.00053 1.00053 0 1 0 -1.28124 1.5371l24 20a1.00038 1.00038 0 0 0 1.248.0254l34-26a.99966.99966 0 0 0 -1.21484-1.5879z"
      />
      <path d="m49.3418 22.75293a1.00007 1.00007 0 1 0 1.3164-1.50586l-16-14a1.00007 1.00007 0 0 0 -1.3164 1.50586z" />
      <path d="m42.8418 28.25293a1.00007 1.00007 0 1 0 1.3164-1.50586l-16-14a1.00007 1.00007 0 1 0 -1.3164 1.50586z" />
      <path d="m36.3418 33.75293a1.00007 1.00007 0 1 0 1.3164-1.50586l-16-14a1.00007 1.00007 0 0 0 -1.3164 1.50586z" />
      <path
        d="m30.5 39.5a1 1 0 0 0 .6582-1.75293l-16-14a1.00007 1.00007 0 0 0 -1.3164 1.50586l16 14a.99408.99408 0 0 0 .6582.24707z"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: "M4PaperStackSvg"
};
</script>
